import { Role, Status } from "../userRoleList/state";
import { userDataList } from "./state";

export function inputFormUsernameAction(username: string) {
    return {
        type: "@@UserForm/inputUsernameAction" as const,
        username,
    };
}

export function inputFormPasswordAction(password: string) {
    return {
        type: "@@UserForm/inputPasswordAction" as const,
        password,
    };
}

export function inputFormRepeatPasswordAction(repeatPassword: string) {
    return {
        type: "@@UserForm/inputRepeatPasswordAction" as const,
        repeatPassword,
    };
}

export function changeRoleAction(role: Role) {
    return {
        type: "@@UserForm/changeRoleAction" as const,
        role,
    };
}

export function inputFormEmailAction(email: string) {
    return {
        type: "@@UserForm/inputFormEmailAction" as const,
        email,
    };
}

export function inputFormTruckAction(truck: string) {
    return {
        type: "@@UserForm/inputFormTruckAction" as const,
        truck,
    };
}

export function clearInputFormAction() {
    return {
        type: "@@UserForm/clearInputFormAction" as const,
    };
}

export function initUserListAction(userList: userDataList[]) {
    return {
        type: "@@UserForm/initUserList" as const,
        userList,
    };
}

export function selectedEditUserAction(userData: userDataList) {
    return {
        type: "@@UserForm/selectedEditUserAction" as const,
        userData,
    };
}
export function selectedUserStatusAction(status: Status) {
    return {
        type: "@@UserForm/selectedUserStatusAction" as const,
        status,
    };
}

export type UserFormAction =
    | ReturnType<typeof inputFormUsernameAction>
    | ReturnType<typeof inputFormPasswordAction>
    | ReturnType<typeof inputFormRepeatPasswordAction>
    | ReturnType<typeof changeRoleAction>
    | ReturnType<typeof clearInputFormAction>
    | ReturnType<typeof inputFormEmailAction>
    | ReturnType<typeof inputFormTruckAction>
    | ReturnType<typeof initUserListAction>
    | ReturnType<typeof selectedEditUserAction>
    | ReturnType<typeof selectedUserStatusAction>;
